import { useQuery } from '@tanstack/react-query'

import type { GetReservationByIdResponse } from '../../types/reservation.js'

import { apiClient } from '../../lib/client.js'
import { reservationKeys } from '../estimate/reservation/keys.js'
import { reservationAuthHeaders } from './reservation-token.js'

/**
 * Demande de réservation vue hors session, derrière le jeton de portée
 * `reservation` — jamais le jeton de session, qui n'ouvre pas cette route.
 */
export const useGetPublicReservationQuery = (reservationId: string, enabled: boolean) =>
  useQuery({
    enabled,
    queryFn: async () => {
      const response = await apiClient.client.get<GetReservationByIdResponse>(
        `/public/reservations/${reservationId}`,
        { headers: reservationAuthHeaders(reservationId) }
      )

      return response.data
    },
    queryKey: reservationKeys.publicById(reservationId),
  })
